import { useCallback, useEffect, useMemo, useState } from 'react';
import timer from '~/assets/icons/timer.svg';
import { CollectionImage } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { CaseType } from '~/shared';
import {
	setActiveBundle,
	setActiveCase,
	setShopKitOpen,
	setShopOpenCaseVisible,
	setTabIndex,
	useLayoutDispatch,
} from '../../redux';
import { formatTime } from '../../utils';
import {
	StyledBannerTextContainer,
	StyledBGText,
	StyledCaseBG,
	StyledCaseImageContainer,
	StyledContainer,
	StyledDot,
	StyledRightContainer,
	StyledTimerContainer,
} from './ShopBanner.styled';

const ShopBanner = () => {
	const dispatch = useLayoutDispatch();
	const cases = useObservable(rage.cases.getLootboxes());
	const bundles = useObservable(rage.cases.getBundles());
	const [endTime, setEndTime] = useState({ time: '', unit: '' });

	const bannerLootbox = useMemo(
		() => cases.find((item) => item.showOnBanner),
		[cases],
	);

	const bannerBundle = useMemo(
		() => bundles.find((item) => item.showOnBanner),
		[bundles],
	);

	const bannerCase = useMemo(
		() => bannerLootbox || bannerBundle,
		[bannerLootbox, bannerBundle],
	);

	const handleClick = useCallback(async () => {
		if (!bannerCase) {
			return;
		}

		if (rage.cases.getCaseTypeById(bannerCase?.id) === CaseType.CASE) {
			const selectedCase = rage.cases.getLootboxById(bannerCase?.id);
			const { getClientConfig: _getClientConfig, ...caseWithoutConfig } =
				selectedCase as any;
			dispatch(setActiveCase(caseWithoutConfig));
			dispatch(setShopOpenCaseVisible(true));
			dispatch(setTabIndex(1));
		} else {
			const selectedBundle = rage.cases.getBundleById(bannerCase?.id);
			const { getClientConfig: _getClientConfig, ...bundleWithoutConfig } =
				selectedBundle as any;
			dispatch(setActiveBundle(bundleWithoutConfig));
			dispatch(setShopKitOpen(true));
			dispatch(setTabIndex(1));
		}
	}, [bannerCase]);

	const countTime = useCallback(() => {
		if (!bannerCase?.enabledTimestampEnd) {
			return;
		}

		const time = formatTime(bannerCase.enabledTimestampEnd || null);
		setEndTime(time);
	}, [bannerCase]);

	useEffect(() => {
		countTime();
		const interval = setInterval(countTime, 100);
		return () => clearInterval(interval);
	}, [countTime]);

	return (
		<StyledContainer>
			<StyledBGText>{bannerCase?.name}</StyledBGText>
			<StyledCaseImageContainer>
				<StyledCaseBG />
				<CollectionImage
					collection={'cases'}
					id={bannerCase?.id ?? ''}
					size={512}
				/>
			</StyledCaseImageContainer>
			<StyledBannerTextContainer>
				<Text>{bannerCase?.name}</Text>
				<Text>
					Успей купить уникальный набор Lamborghini OLD по скидки и получи
					возможность забрать эксклюзивный Lamborghini Countach 1979 года
				</Text>
			</StyledBannerTextContainer>
			<StyledRightContainer>
				<StyledTimerContainer
					style={{ visibility: endTime.time ? 'visible' : 'hidden' }}
				>
					<Text style={{ opacity: 0.5 }}>До конца акции осталось</Text>
					<img src={timer} />
					<Text>
						<span style={{ fontWeight: 700 }}>{endTime.time}</span>
						{endTime.unit && (
							<span style={{ fontWeight: 400, opacity: 0.5 }}>
								&nbsp;{endTime.unit}
							</span>
						)}
					</Text>
				</StyledTimerContainer>
				<StyledDot />
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					onClick={handleClick}
					style={{ fontSize: 14, fontWeight: 500, width: 158 }}
				>
					<Text>Узнать подробнее</Text>
				</Button>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { ShopBanner };
